import { SET_IS_EMERGENCY } from 'actions';

export function setIsEmergency(isEmergency: boolean) {
  return { isEmergency, type: SET_IS_EMERGENCY };
}
